function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { setHOCDisplayName } from '@domain-group/fe-helper';

/* Deprecated -  access `toggledFeatures` via fe-co-allhomes-global-context */
import { jsx as ___EmotionJSX } from "@emotion/core";
var toggledFeatureConsumer = BaseComponent => {
  class ToggledFeatureConsumer extends React.Component {
    constructor(props, context) {
      super(props, context);
      this.state = {
        toggledFeatures: context.toggledFeatures
      };
    }

    /* eslint-disable-next-line react/no-deprecated */
    componentWillReceiveProps(nextProps, nextContext) {
      if (!isEqual(this.state.toggledFeatures, nextContext.toggledFeatures)) {
        this.setState({
          toggledFeatures: nextContext.toggledFeatures
        });
      }
    }
    render() {
      return ___EmotionJSX(BaseComponent, _extends({
        toggledFeatures: this.state.toggledFeatures
      }, this.props));
    }
  }
  ToggledFeatureConsumer.contextTypes = {
    toggledFeatures: PropTypes.objectOf(PropTypes.bool)
  };
  setHOCDisplayName(ToggledFeatureConsumer, BaseComponent, 'toggledFeatureConsumer');
  return hoistNonReactStatics(ToggledFeatureConsumer, BaseComponent);
};
export default toggledFeatureConsumer;